import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CotactlistModel from "../../models/contact.model";
import { helper } from "lib/helper";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
  Form,
  Table,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import AddModal from "views/components/AddModal";

const Contactlist = () => {
  const [data, setData] = useState();
  const [modal4, setModal4] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [detail, setDetail] = useState();
  const [id, setId]=useState();
  const[iid, SetIid]=useState();
  const[image, setImage]=useState();
  const [addData, setAddData] = useState({
    name: "",
    contact_no: "",
    email: "",
    whatsapp_no: "",
    profile_pic: null,
    designation: "",
    purpose_for_call: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    contact_no: "",
    email: "",
    whatsapp_no: "",
    profile_pic: null,
    designation: "",
    purpose_for_call: "",
  });
  useEffect(() => {
    if (modal1) {
      setFormData({
        name: detail?.name || "",
        contact_no: detail?.contact_no || "",
        email: detail?.email || "",
        whatsapp_no: detail?.whatsapp_no || "",
        profile_pic: null,
        designation: detail?.designation || "",
        purpose_for_call: detail?.purpose_for_call || "",
      });
    }
  }, [modal1, detail]);

  const toggleModal4 = () => {
    setModal4(!modal4);
  };
  const[modal5, setModal5] =useState(false);
const toggleModal5 =()=>{
  setModal5(!modal5);
}
  const toggleModal1 = (id) => {
    setModal1(!modal1);
    Getdetail(id);
  };

  const Getdetail = async (id) => {
    // Simulate getting contact details
    const contact = data?.find(item => item.id === id);
    if (contact) {
      setDetail(contact);
    }
  };
  const Addcontact = async (event) => {
    event.preventDefault();

    const formdata = new FormData(event.target);
    
    // Simulate adding new contact
    const newContact = {
      id: (data?.length + 1).toString(),
      name: formdata.get("name"),
      contact_no: formdata.get("contact_no"),
      email: formdata.get("email"),
      whatsapp_no: formdata.get("whatsapp_no"),
      designation: formdata.get("designation"),
      purpose_for_call: formdata.get("purpose_for_call[]"),
      profile_pic: {
        link: "https://via.placeholder.com/150/0000FF/FFFFFF?text=New"
      }
    };
    
    setTimeout(() => {
      setData(prevData => [...(prevData || []), newContact]);
      helper.sweetalert.toast("Contact added successfully", "success");
      setModal4(false);
    }, 500);
  };
  const DeleteContact = () => {
    // Simulate deleting contact
    setTimeout(() => {
      setData(prevData => prevData?.filter(item => item.id !== id));
      helper.sweetalert.toast("Contact deleted successfully", "success");
    }, 500);
  };

  const Update = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    
    // Simulate updating contact
    setTimeout(() => {
      setData(prevData => 
        prevData?.map(item => 
          item.id === iid 
            ? {
                ...item,
                name: formData.get("name") || item.name,
                contact_no: formData.get("contact_no") || item.contact_no,
                email: formData.get("email") || item.email,
                whatsapp_no: formData.get("whatsapp_no") || item.whatsapp_no,
                designation: formData.get("designation") || item.designation,
                purpose_for_call: formData.get("purpose_for_call[]") || item.purpose_for_call
              }
            : item
        )
      );
      helper.sweetalert.toast("Contact updated successfully", "success");
      setModal1(false);
    }, 500);
  };



  const getListData = async () => {
    // Dummy data for contact list
    const dummyData = [
      {
        id: "1",
        name: "Dr. Rajesh Kumar",
        designation: "Academic Director",
        email: "rajesh.kumar@edushala.com",
        contact_no: "9876543210",
        whatsapp_no: "9876543210",
        purpose_for_call: "Academic Queries",
        profile_pic: {
          link: "https://via.placeholder.com/150/FF0000/FFFFFF?text=RK"
        }
      },
      {
        id: "2",
        name: "Ms. Priya Sharma",
        designation: "Student Counselor",
        email: "priya.sharma@edushala.com",
        contact_no: "9876543211",
        whatsapp_no: "9876543211",
        purpose_for_call: "Student Support",
        profile_pic: {
          link: "https://via.placeholder.com/150/00FF00/FFFFFF?text=PS"
        }
      },
      {
        id: "3",
        name: "Mr. Amit Verma",
        designation: "Technical Support",
        email: "amit.verma@edushala.com",
        contact_no: "9876543212",
        whatsapp_no: "9876543212",
        purpose_for_call: "Technical Issues",
        profile_pic: {
          link: "https://via.placeholder.com/150/0000FF/FFFFFF?text=AV"
        }
      },
      {
        id: "4",
        name: "Mrs. Sunita Gupta",
        designation: "Parent Relations",
        email: "sunita.gupta@edushala.com",
        contact_no: "9876543213",
        whatsapp_no: "9876543213",
        purpose_for_call: "Parent Concerns",
        profile_pic: {
          link: "https://via.placeholder.com/150/FF00FF/FFFFFF?text=SG"
        }
      },
      {
        id: "5",
        name: "Mr. Vikash Singh",
        designation: "Tutor Coordinator",
        email: "vikash.singh@edushala.com",
        contact_no: "9876543214",
        whatsapp_no: "9876543214",
        purpose_for_call: "Tutor Registration",
        profile_pic: {
          link: "https://via.placeholder.com/150/FFFF00/000000?text=VS"
        }
      }
    ];
    
    setTimeout(() => {
      setData(dummyData);
    }, 1000);
  };
  useEffect(() => {
    getListData();
  }, []);
 
  return (
    <>
      <div className="px-4 py-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Contact List</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  {/*<Input
                  className="mr-4"
                  type="text"
                  placeholder="Search"
                  size="sm"
                />*/}
                  <Button
                    size="sm"
                    
                    onClick={toggleModal4}
                    style={{ backgroundColor: "#080278", color: "white" }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.NO</th>
                    <th scope="col">Profile pic</th>
                    <th scope="col">Name</th>
                    <th scope="col">Desgination</th>
                    <th scope="col">EMAIL</th>
                    <th scope="col">PHONE NO</th>

                    {/* <th scope="col">Password</th> */}

                    <th>Action</th>
                    <th scope="col" />
                  </tr>
                </thead>
                    
                <tbody>
                  {data?.map((data, key) => {
                  
                    return (
                      <tr style={{ cursor: "pointer" }} key={key}>
                        <td>{key + 1}</td>
                        <td title="Click on me" onClick={()=>{
                          toggleModal5();
                          setImage(data?.profile_pic?.link)}}>
                          <img src={data?.profile_pic?.link} height="30px" />
                        </td>
                        <td>{data?.name}</td>
                        <td>{data?.designation}</td>
                        <td>{data?.email}</td>
                        <td>{data?.contact_no}</td>

                        <td
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            // justifyContent: "center",
                            // alignItems: "center",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="top"
                            target="eyeTooltip"
                          >
                            Edit
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="eyeTooltip"
                            onClick={() => {
                              toggleModal1(data?.id);
                              SetIid(data?.id)
                            }}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </Link>

                          <UncontrolledTooltip
                            placement="top"
                            target="userTooltip"
                          >
                            Delete
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 8px",
                              fontSize: "15px",
                              color: "red",
                              marginTop: "10px",
                              // backgroundColor: "#f5f5f5",
                              display: "inline-block",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "20%", // Optional: Make it a circle
                            }}
                            id="userTooltip"
                            onClick={()=>{
                              setId(data?.id);
                              DeleteContact();}}
                          >
                            <i className="fas fa-trash" ></i>
                          </p>
                        </td>
                        <Modal isOpen={modal1} toggle={toggleModal1} size="lg">
                          <ModalHeader>
                            <h4> Edit Contact</h4>
                          </ModalHeader>
                          <ModalBody>
                          <Form onSubmit={Update}>
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label > Name </Label>
                                  <Input
                                    name="name"
                                    type="text"
                                    placeholder={detail?.name}
                                    
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup>
                                  <Label >Contact No</Label>
                                  <Input
                                    name="contact_no"
                                    type="text"
                                    placeholder={detail?.contact_no}
                                    
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label >E-Mail </Label>
                                  <Input
                                    name="email"
                                    type="text"
                                    placeholder={detail?.email}
                                   
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup>
                                  <Label >Whatup No</Label>
                                  <Input
                                    name="whatsapp_no"
                                    type="text"
                                    placeholder={detail?.whatsapp_no}
                                    
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label >Profile Pic</Label>
                                  <Input
                                    type="file"
                                    id="profilePicInput"
                                    name="profile_pic"
                                    style={{
                                      border: "1px solid #cad1d7",
                                      borderRadius: "0.375rem",
                                      padding: "5px",
                                    }}
                                    
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup>
                                  <Label >Designation</Label>

                                  <Input
                                    id="forType"
                                    name="designation"
                                    type="text"
                                    placeholder={detail?.designation}
                                   
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={12}>
                                <FormGroup>
                                  <Label >
                                    Purpose_for_call
                                  </Label>
                                  <Input
                                    name="purpose_for_call[]"
                                    type="text"
                                    placeholder={detail?.purpose_for_call}
                                    
                                    
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "20px",
                              }}
                            >
                              <Button
                                color="secondary"
                                onClick={() => {
                                  setModal1(false);
                                }}
                              >
                                Cancel
                              </Button>
                              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                              <Button
                                color="primary"
                                type="submit"
                                style={{
                                  float: "right",
                                  marginLeft: "5%",
                                  backgroundColor: "#080278",
                                  color: "white",
                                }}
                                onClick={() => {
                                 
                                 
                                }}
                              >
                                Save
                              </Button>
                            </div>
                            </Form>
                          </ModalBody>
                        </Modal>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>

        <Modal isOpen={modal4} toggle={toggleModal4} size="lg">
          <ModalHeader toggle={toggleModal4}>
            <h4> Add Contact</h4>
          </ModalHeader>
          
          <ModalBody>
            <Form onSubmit={Addcontact}>
              <Row>
                <Col md={6}>
                 
                    <Label> Name </Label>
                    <Input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Enter Name"
                    
                    />
                  
                </Col>
                <Col md={6}>
                  
                    <Label>Contact No</Label>
                    <Input id="contact_no" name="contact_no" type="text" placeholder="Enter Contact No"  />
                 
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                 
                    <Label>E-Mail </Label>
                    <Input id="email" name="email" type="text" placeholder="Enter E-Mail" />
                  
                </Col>
                <Col md={6}>
                  
                    <Label>Whatup No</Label>
                    <Input id="whatsapp_no" name="whatsapp_no" type="text" placeholder="Whatup No" />
                  
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                 
                    <Label>Profile Pic</Label>
                    <Input
                      
                      type="file"
                      placeholder="Enter Email Address"
                     id="profile_pic"
                      name="profile_pic"
                      style={{
                        border: "1px solid #cad1d7",
                        borderRadius: "0.375rem",
                        padding: "5px",
                      }}
                    />
                  
                </Col>
                <Col md={6}>
                  
                    <Label>Designation</Label>

                    <Input
                    id="designation"
                     name="designation"
                      type="text"
                      placeholder="Desiganation"

                    />
                  
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  
                    <Label>Purpose_for_call</Label>
                    <Input id="purpose_for_call[]" name="purpose_for_call[]" type="text" placeholder=" Enter Purpose for call" />
                  
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal4}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}
                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
          
        </Modal>
        <Modal isOpen={modal5} toggle={toggleModal5} size="lg">
      <ModalHeader toggle={toggleModal5}>
          <h4>Banner</h4>
        </ModalHeader>
        <ModalBody >
         
         <img src={image} width="750px" height="460px"  style={{ 
            maxWidth: "100%", // Makes the image scale within the container width
            height: "auto",   // Keeps the aspect ratio intact
            border: "2px solid gray"
          }} />
        </ModalBody></Modal>
      </div>
    </>
  );
};

export default Contactlist;
